import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

import { LoaderService } from '@shared/components';
import { LanguageService } from './i18n';
import { AccountMessagesService, BackButtonService } from './core/libraries';
import { MessagesService } from './core/messages';
import { MetricsService } from './core/metrics';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterOutlet],

    providers: [AccountMessagesService],
})
export class AppComponent implements OnInit {
    readonly loaderService = inject(LoaderService);
    private readonly messagesService = inject(MessagesService);
    private readonly languageService = inject(LanguageService);
    private readonly accountMessagesService = inject(AccountMessagesService);
    private readonly backButtonService = inject(BackButtonService);
    private readonly metricsService = inject(MetricsService);

    ngOnInit(): void {
        // Must run on every launch, unconditionally — the plugin rolls back the bundle without it.
        if (Capacitor.isNativePlatform()) {
            void CapacitorUpdater.notifyAppReady();
        }

        this.languageService.init();
    }
}
